export default "__VITE_ASSET__C4QCwBPg__"